import { type ReactNode, type RefCallback } from 'react';

import { YStack } from '@/components/ui';
import { cn } from '@/lib/utils';

import { type SidebarSectionName } from './sticky-section';

const STATIC_STICKY_SECTIONS = ['projects', 'favorites', 'recents'] as const;

export function StickySectionHeading({
  headings,
  onPortalTargetChange,
  section,
}: {
  headings: Record<Exclude<SidebarSectionName, 'routines'>, ReactNode>;
  onPortalTargetChange: RefCallback<HTMLDivElement>;
  section: SidebarSectionName | null;
}) {
  const isPortalSection = section === 'routines';

  return (
    <YStack
      aria-hidden={section ? undefined : true}
      inert={section ? undefined : true}
      data-testid="sticky-sidebar-section-heading"
      className={cn(
        'absolute left-0 top-0 z-20',
        'right-0',
        !section && 'invisible pointer-events-none'
      )}
    >
      <div className="grid">
        {STATIC_STICKY_SECTIONS.map((stickySection) => {
          const isActive = section === stickySection;

          return (
            <div
              key={stickySection}
              aria-hidden={isActive ? undefined : true}
              inert={isActive ? undefined : true}
              data-sticky-sidebar-section-layer={stickySection}
              className={cn(
                'col-start-1 row-start-1',
                !isActive && 'invisible pointer-events-none'
              )}
            >
              {headings[stickySection]}
            </div>
          );
        })}
        <div
          ref={onPortalTargetChange}
          aria-hidden={isPortalSection ? undefined : true}
          inert={isPortalSection ? undefined : true}
          data-sticky-sidebar-section-layer="routines"
          className={cn(
            'col-start-1 row-start-1',
            !isPortalSection && 'invisible pointer-events-none'
          )}
        />
      </div>
    </YStack>
  );
}
